module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dionigi Albera, Maria Couroucli\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Dionigi Albera is Senior Researcher at the Centre National de la Recherche Scientifique and Director of the Institut d'Ethnologie Méditerranéenne et Comparative.")]), _c('P', [_vm._v("Maria Couroucli is Senior Researcher at the Centre National de la Recherche Scientifique, Laboratoire d'Ethnologie et Sociologie Comparative.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HccbWI/tc-custom/9780253016904.jpg?1718251155887",
      "alt": "This image is the cover for the book Sharing Sacred Spaces in the Mediterranean, New Anthropologies of Europe"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sharing Sacred Spaces in the Mediterranean, New Anthropologies of Europe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Will spark debate . . . and hopefully further research into points of contact between the monotheistic religions, and others.” —"), _c('i', [_vm._v("The Levantine Review")])]), _c('br'), _c('br'), _vm._v("While devotional practices are usually viewed as mechanisms for reinforcing religious boundaries, in the multicultural, multiconfessional world of the Eastern Mediterranean, shared shrines sustain intercommunal and interreligious contact among groups."), _c('br'), _c('br'), _vm._v("Heterodox, marginal, and largely ignored by central authorities, these practices persist despite aggressive, homogenizing nationalist movements. This volume challenges much of the received wisdom concerning the three major monotheistic religions and the “clash of civilizations,” as contributors examine intertwined religious traditions along the shores of the Near East from North Africa to the Balkans.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0